import { runDemo } from "../shared/demoRunner";
import { createFurScene } from "./scene";

runDemo({ createScene: createFurScene });
